import React from 'react'

const SettingClient=()=>{
console.log("hola")
return(
<>
<h1>Configuracion</h1>
</>

)
}
export default SettingClient